import $ from "cash-dom";
import globals from "imports/globals";
import { gsapTrigger as WyPt, mapValue, clamp } from "Utilities";

const layout = (function () {
    function refocusImage(_this) {
        var values = {
            x: parseFloat($(_this).attr("data-x")),
            y: parseFloat($(_this).attr("data-y")),
            zoom: $(_this).attr("data-zoom"),
        };

        var image = _this.parentElement.previousElementSibling.querySelector(".panning-image-element .source-image");
        var max = 100;
        var mod = values.zoom * Math.pow(1.1, values.zoom);
        var offsetX = mapValue(values.x, 0, 100, -max / mod, max / mod);
        var offsetY = mapValue(values.y, 0, 100, -max / mod, max / mod);
        var x = clamp(values.x + offsetX, 0, 100);
        var y = clamp(values.y + offsetY, 0, 100);

        console.log(offsetX, offsetY);

        image.style.transformOrigin = `${x}% ${y}%`;
        image.style.transform = `scale(${values.zoom})`;
    }
    /**
     * Initialize Panning Image instances
     */
    $(document).ready(function () {
        if ($(".layout-panning-image").length) {
            if (globals.debug) console.log("layout-panning-image initialized");
            var keyframes = [];
            $(".layout-panning-image")
                .find(".keyframe")
                .each(function () {
                    var caption = $(this).parents(".layout-panning-image").find(".dynamic-caption");
                    var captionText = caption.find(".dynamic-caption-content");
                    keyframes.push(
                        new WyPt({
                            element: $(this)[0],
                            offset: {
                                top: "top-top",
                                bottom: "bottom-top",
                            },
                            // pointMode: true,
                            // debug: true,
                            callback: {
                                enter: function (_el, _dir) {
                                    $(_el).addClass("in-view");
                                    var empty = _el.hasAttribute("data-empty");
                                    refocusImage(_el);

                                    if (!empty) {
                                        caption.addClass("on");
                                        globals.replaceText(_el, captionText);
                                    } else {
                                        caption.removeClass("on");
                                    }
                                },
                                leave: function (_el, _dir) {
                                    $(_el).removeClass("in-view");
                                    if (!_el.previousElementSibling || !_el.nextElementSibling) {
                                        globals.resetImage(_el);
                                    }
                                },
                            },
                        })
                    );
                });

            /*
            $(".layout-panning-image").each(function () {
                new WyPt({
                    element: $(this)[0],
                    offset: {
                        top: "top-bottom",
                        bottom: "bottom-top",
                    },
                    callback: {
                        enter: function () {
                            if (!globals.isScrolling) $("html").addClass("scroll-snap-y");
                        },
                        leave: function () {
                            $("html").removeClass("scroll-snap-y");
                        },
                    },
                });
            });
            */
        }
    });
})();

export default layout;
